import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mileage-counter',
  templateUrl: './mileage-counter.component.html',
  styleUrls: ['./mileage-counter.component.scss']
})
export class MileageCounterComponent {


  @Input() MileageCounter: number | null | undefined = 0;
  @Input() AmountOfDigites: number = 6;

  digitArray: string[] = [];

  ngOnChanges() {
    if (this.MileageCounter) {
      const padded = this.MileageCounter.toString().padStart(this.AmountOfDigites, '0');
      this.digitArray = padded.split('');
    }

  }
}
